import { render, staticRenderFns } from "./yiliaofuwu_hjtj.vue?vue&type=template&id=0d24f3a0&scoped=true"
import script from "./yiliaofuwu_hjtj.vue?vue&type=script&lang=js"
export * from "./yiliaofuwu_hjtj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24f3a0",
  null
  
)

export default component.exports